<template>
    <div id="app">
		<!-- 面包屑导航 -->
		<el-breadcrumb separator="/">
		    <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
		    <el-breadcrumb-item><a href="/">站点</a></el-breadcrumb-item>
		    <el-breadcrumb-item>站点配置</el-breadcrumb-item>
		</el-breadcrumb>
        <!-- 卡片视图区域 -->
        <el-card>
			
			<el-form ref="form" label-width="80px" class="from">
			    <el-form-item label="站点简介">
			        <el-input type="text" v-model="desc"></el-input>
			    </el-form-item>
			
			    <el-form-item label="网站名称">
			        <el-input type="text" v-model="name"></el-input>
			    </el-form-item>
				
				<el-form-item label="网站标题">
				    <el-input type="text" v-model="title"></el-input>
				</el-form-item>
			
			    <el-form-item class="btns">
			        <el-button type="primary" @click="submit">修改站点</el-button>
			    </el-form-item>
			</el-form>
			
        </el-card>
    </div>
</template>

<script>
	import {pages} from '@/api/index.js'
	export default{
		data(){
			return{
				desc:'',
				name:'',
				title:''
			}
		},
		created(){
			
		},
		methods:{
			async submit(){
				const {data:res} = await pages({
					desc:this.desc,
					name:this.name,
					title:this.title
				})
				console.log(res);
			}
		}
	}
</script>

<style scoped>
.el-card {
    margin-top: 20px;
}
</style>
